<template>
  <footer v-if="isZentrolink" class="zentrolink-footer neue" data-testid="zentrolink-footer">
    <div
      v-if="testEnvironmentNoticeEnabled"
      class="zentrolink-footer__notice"
      role="status"
      data-testid="test-environment-notice"
    >
      <strong>{{ $t('components.service.ZentrolinkFooter.1') }}</strong>
      <span>{{ $t('components.service.ZentrolinkFooter.2') }}</span>
    </div>
    <div class="zentrolink-footer__legal">
      <p>{{ $t('components.service.ZentrolinkFooter.3') }}</p>
      <nav :aria-label="$t('components.service.ZentrolinkFooter.4')">
        <router-link to="/legal/terms">{{ $t('components.service.ZentrolinkFooter.5') }}</router-link>
        <router-link to="/legal/privacy">{{ $t('components.service.ZentrolinkFooter.6') }}</router-link>
        <router-link to="/legal/datenschutz">{{ $t('components.service.ZentrolinkFooter.7') }}</router-link>
      </nav>
    </div>
  </footer>
</template>

<script>
import { hasZentrolinkFooter } from '@/includes/footerBrand';
export default {
  name: 'ZentrolinkFooter',
  computed: {
    isZentrolink() {
      return hasZentrolinkFooter(this.$store.state.individual);
    },
    testEnvironmentNoticeEnabled() {
      return this.$store.state.runtimeEnvironment?.testEnvironmentNotice?.enabled === true;
    }
  }
};
</script>

<style lang="scss" scoped>
.zentrolink-footer {
  width: 100%;
  flex: 0 0 auto;
  color: #292d32;
  background: #fff;
  border-top: 1px solid #d9dde3;
  font-size: 14px;
  line-height: 20px;
}

.zentrolink-footer__notice {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px max(24px, calc((100% - 1320px) / 2));
  color: #5c3100;
  background: #fff3df;
  border-bottom: 1px solid #f0c98d;
}

.zentrolink-footer__legal {
  max-width: 1320px;
  margin: 0 auto;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px 32px;
}

p { margin: 0; }
nav { display: flex; flex-wrap: wrap; gap: 12px 24px; }
a { color: #9a4700; text-decoration: underline; text-underline-offset: 3px; }
a:focus-visible { outline: 3px solid #ff7f11; outline-offset: 3px; border-radius: 2px; }

@media (max-width: 575px) {
  .zentrolink-footer__notice { padding: 16px; }
  .zentrolink-footer__legal { align-items: flex-start; flex-direction: column; padding: 20px 16px; }
  nav { flex-direction: column; gap: 12px; }
}
</style>
